var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { isAMPMFormat, getDatetimeFormat } from 'ezyvet-fe-helpers';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import DateProvider from './DateProvider';
/**
 * @deprecated
 * Use `DatetimeInput` to render a datetime field
 */
export function DatetimeInput(props) {
    var format = props.format, showSeconds = props.showSeconds, otherProps = __rest(props, ["format", "showSeconds"]);
    return (React.createElement(DateProvider, __assign({ Input: KeyboardDateTimePicker }, otherProps, { ampm: isAMPMFormat(format), format: getDatetimeFormat(format, showSeconds) })));
}
DatetimeInput.defaultProps = {
    format: 'dd/MM/yyyy h:mm:ss a',
    showSeconds: false,
};
export default DatetimeInput;
//# sourceMappingURL=DatetimeInput.js.map